module.exports = __webpack_public_path__ + "img/img_C3.13.1.9af93638.png";